/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';

import {TrainClass}      from '@/models/scenario/train.class';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class TrainClassesRenderer
 *
 * @brief cell rendering a group of train classes
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TrainClassesRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: TrainClass[] = [];

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui           = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;"></span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value;

    if (!this.value) {

      this.gui.innerHTML = `<span style="color: grey;"></span>`;
      return ;
    }

    if (!Array.isArray(this.value)) {

      this.value = [this.value];
    }

    /* build the list of train names */

    let text: string = '';

    for (const trainClass of this.value) {

      if (text.length) {

        text += ', ';
      }

      text += trainClass._name;
    }

    /* limit the size that we show ... */

    if (text.length >= 24) {

      text = text.substring(0, 24) + '...';
    }

    /* render */

    this.gui.innerHTML = `<span style="color: grey;">${text}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
